import { PricingTaxi } from '../../../shared/types';
import React, { createContext, useContext, useState } from 'react';

type ContextType<S> = [S, React.Dispatch<React.SetStateAction<S>>] | null;

const initialState = null;
const PricingInfoContext = createContext<ContextType<PricingTaxi>>(null);
PricingInfoContext.displayName = 'PricingInfoContext';

function useCurrentZoneTimePricingTaxi() {
    const context = useContext(PricingInfoContext);
    if (!context) {
        throw new Error(`useCurrentZoneTimePricingTaxi must be used within a PricingInfoProvider`);
    }

    const [currentPricing, setCurrentPricing] = context;

    return {
        currentPricing,
        setCurrentPricing,
    };
}

function PricingTaxiInfoProvider(props) {
    const pricing = useState(initialState);
    return <PricingInfoContext.Provider value={pricing} {...props} />;
}

export { PricingTaxiInfoProvider, useCurrentZoneTimePricingTaxi };
